package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.invoice.ui.allinvoice.InvoiceEvent
import com.essntl.features.invoice.ui.allinvoice.InvoiceState
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.domain.model.shareLink
import com.essntl.features.itinerary.ui.*
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryState
import com.essntl.features.itinerary.ui.edit_itinerary.MessageSendType
import com.essntl.features.itinerary.ui.edit_itinerary.utils.getPdfState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.ui.addeditproposal.components.InvoicesDialog
import com.essntl.features.task.ui.TaskColumnDialog
import com.essntl.toastmanager.IO
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.card.CardInfo
import com.essntl.uikit.components.card.TodayDateCard
import com.essntl.uikit.components.datepicker.EsDateRangePickerDialog
import com.essntl.uikit.components.file.launch
import com.essntl.uikit.components.file.rememberFileSaverLauncher
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsLargePrimaryIconButton
import com.essntl.uikit.components.iconbutton.primary.EsMediumPrimaryIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.iconbutton.secondary.EsLargeSecondaryIconButton
import com.essntl.uikit.components.iconbutton.tinted.EsLargeTintedIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.generated.resources.Res
import com.essntl.uikit.rememberContains
import com.essntl.uikit.rememberFind
import com.essntl.uikit.resources.LocalRes
import com.essntl.uikit.theme.Branding
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.ExperimentalCalfApi
import core.config.FeatureConfig
import core.dateformat.ui.formatDateRange
import core.pdf.itinerary.ItineraryPdfState
import core.pdf.itinerary.createItineraryPdf
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.koin.compose.koinInject

@OptIn(ExperimentalCalfApi::class, ExperimentalResourceApi::class)
@Composable
fun ColumnScope.ItineraryServicesHeader(
    state: EditItineraryState,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit,
    onAddServiceClick: () -> Unit,
    selectedItineraryServiceList: List<ItineraryServiceModel>,
    isConcierge: Boolean,
    onShareItineraryClick: (String) -> Unit,
    invoiceState: InvoiceState,
    onInvoiceEvent: (InvoiceEvent) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isDateRangePickerVisible by remember { mutableStateOf(false) }
    val itineraryModel = state.getAllItinerary.data?.firstOrNull() ?: ItineraryModel.empty
    val itineraryServices = state.getAllItineraryService.data ?: emptyList()

    val confirmedItineraryServicesList = rememberConfirmedItineraryServicesList(itineraryServices)

    val clients = rememberContains(
        state.getAllClient.data.orEmpty(),
        state.getAllItinerary.data
            ?.firstOrNull()
            ?.proposal?.clients.orEmpty().toSet(),
    ) { client -> client.id }

    var isClientInformationDialogExpanded by rememberSaveable { mutableStateOf(false) }

    var isAllTaskDialogExpanded by rememberSaveable { mutableStateOf(false) }

    var isDatesDialogExpanded by rememberSaveable { mutableStateOf(false) }

    val proposal = state.getAllItinerary.data
        ?.firstOrNull()
        ?.proposal

    val todosCount = rememberTodosCount(state.getAllItineraryTask.data)

    val primaryClient = rememberFind(
        clients,
        itineraryModel.proposal?.primaryClient?.id,
    ) { client -> client.id }

    var isInvoicesDialogOpen by rememberSaveable { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        if (isConcierge) {
            Text(
                text = "Concierge",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h2Bold32,
            )
        } else {
            SelectionContainer {
                Column {
                    Row {
                        Text(
                            text = itineraryModel.proposal?.title ?: "Itinerary Title",
                            color = MaterialTheme.esColorScheme.textPrimary,
                            style = MaterialTheme.esTypography.h2Bold32,
                        )
                    }
                    itineraryModel.proposal?.headline?.let {
                        Row {
                            Text(
                                text = it,
                                color = MaterialTheme.esColorScheme.textSecondary,
                                style = MaterialTheme.esTypography.p2Regular14,
                            )
                        }
                    }
                    itineraryModel.proposal?.let {
                        Row {
                            Text(
                                text = "${it.guestCount} " + if (it.guestCount == 1) "traveller" else "travellers",
                                color = MaterialTheme.esColorScheme.textPrimary,
                                style = MaterialTheme.esTypography.p2Regular14,
                            )
                        }
                    }
                }
            }
        }

        Spacer(modifier = Modifier.weight(1F))

        if (isConcierge) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(1.spacing),
                verticalAlignment = Alignment.Bottom,
            ) {
                if (!state.selectedFromDate.isNullOrEmpty() ||
                    !state.selectedToDate.isNullOrEmpty()
                ) {
                    Text(
                        text = listOf(
                            state.selectedFromDate,
                            state.selectedToDate,
                        ).formatDateRange(),
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.c1Medium13,
                    )

                    EsMediumPrimaryIconButton(
                        iconRes = EsIcons.Calendar,
                        onClick = {
                            isDateRangePickerVisible = !isDateRangePickerVisible
                        },
                    )
                } else {
                    EsMediumOutlineIconButton(
                        iconRes = EsIcons.Calendar,
                        onClick = {
                            isDateRangePickerVisible = !isDateRangePickerVisible
                        },
                    )
                }

                ItineraryServiceFilterSection(
                    filterOptions = state.filterOptions,
                    onFilterOptionsChange = {
                        onEvent(EditItineraryEvent.FilterItineraryServices(it))
                    },
                )
            }
        } else {

            if (FeatureConfig.hasQuickBooks) {
                EsLargeSecondaryButton(
                    text = "Invoices",
                    onClick = {
                        isInvoicesDialogOpen = true
                        onInvoiceEvent(
                            InvoiceEvent.GetInvoices(
                                proposalId = "",
                                itineraryId = itineraryModel.id,
                            ),
                        )
                    },
                )

                Spacer(modifier = Modifier.width(1.spacing))
            }

            EsTooltip(
                text = "Open Proposal",
            ) {
                EsLargeSecondaryIconButton(
                    iconRes = EsIcons.Proposal,
                    onClick = {
                        proposal?.let {
                            onNavigation(EditItineraryNavigation.EditProposal(it.id))
                        }
                    },
                )
            }

            Spacer(modifier = Modifier.width(1.spacing))

            EsTooltip(
                text = "Open in web browser",
            ) {
                EsLargePrimaryIconButton(
                    iconRes = EsIcons.Browse,
                    onClick = {
                        itineraryModel.shareLink?.let { link ->
                            onShareItineraryClick(link)
                        }
                    },
                )
            }
        }
    }

    Spacer(modifier = Modifier.height(1.spacing))

    if (isConcierge) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start,
            modifier = modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(
                    vertical = EsConstants.SectionVerticalPadding,
                    horizontal = EsConstants.SectionHorizontalPadding,
                ),
        ) {
            TodayDateCard(
                date = state.startDate,
                onDateSelected = {
                    onEvent(EditItineraryEvent.GetAllItineraryServiceByDate(it))
                },
            )
        }
    } else {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start,
            modifier = modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(
                    vertical = EsConstants.SectionVerticalPadding,
                    horizontal = EsConstants.SectionHorizontalPadding,
                ),
        ) {
            CardInfo(
                title = "Dates",
                information = listOf(
                    itineraryModel.proposal?.fromDate,
                    itineraryModel.proposal?.toDate,
                ).formatDateRange(),
                action = {
                    EsSmallOutlineIconButton(
                        onClick = {
                            isDatesDialogExpanded = true
                        },
                        iconRes = EsIcons.Edit,
                    )
                },
            )

            Spacer(modifier = Modifier.width(2.spacing))

            CardInfo(
                title = itineraryModel.proposal?.guestDetails ?: "Primary traveller",
                information = primaryClient?.prettyName ?: "Primary traveller not set",
                action = {
                    EsSmallOutlineIconButton(
                        onClick = {
                            onNavigation(
                                EditItineraryNavigation.SendMessage(
                                    itineraryServices = confirmedItineraryServicesList,
                                    type = MessageSendType.CLIENT,
                                ),
                            )
                        },
                        enabled = primaryClient != null &&
                            confirmedItineraryServicesList.isNotEmpty(),
                        iconRes = EsIcons.ContactIcon,
                    )

                    Spacer(modifier = Modifier.width(.5f.spacing))

                    EsSmallOutlineIconButton(
                        onClick = {
                            isClientInformationDialogExpanded = true
                        },
                        iconRes = EsIcons.Edit,
                    )
                },
            )

            Spacer(modifier = Modifier.width(2.spacing))

            CardInfo(
                title = "Travel agent",
                information = proposal?.travelAgent?.prettyName ?: "-",
                action = {
                    proposal?.let {
                        EsSmallOutlineIconButton(
                            onClick = {
                                onNavigation(EditItineraryNavigation.ChangeTravelAgent(it))
                            },
                            iconRes = EsIcons.Edit,
                        )
                    }
                },
            )

            Spacer(modifier = Modifier.width(2.spacing))

            val todosInformation = if (todosCount == 0) "" else "$todosCount not completed"
            CardInfo(
                title = "Itinerary Tasks",
                information = todosInformation,
                informationColor =
                    if (todosCount > 0) MaterialTheme.esColorScheme.textWarning.copy(alpha = 0.7f) else Color.White,
                action = {
                    EsSmallOutlineIconButton(
                        onClick = {
                            isAllTaskDialogExpanded = true
                        },
                        iconRes = EsIcons.Eye,
                    )

                    Spacer(modifier = Modifier.width(.5f.spacing))

                    EsSmallPrimaryIconButton(
                        onClick = {
                            state.getAllItinerary.data?.firstOrNull()?.let { itinerary ->
                                itinerary.proposal?.let { proposal ->
                                    onNavigation(
                                        EditItineraryNavigation.AddItineraryTask(
                                            itineraryId = itinerary,
                                            proposalId = proposal.id,
                                        ),
                                    )
                                }
                            }
                        },
                        iconRes = EsIcons.Add,
                    )
                },
            )
        }
    }

    Spacer(modifier = Modifier.height(2.spacing))

    if (selectedItineraryServiceList.isNotEmpty())
        ItineraryServicesSelected(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            itinerary = itineraryModel,
            clients = clients,
            selectedItineraryServiceList = selectedItineraryServiceList,
            itineraryServices = itineraryServices,
            isConcierge = isConcierge,
        )
    else
        HeaderTitles(
            onEvent = onEvent,
            onAddServiceClick = onAddServiceClick,
            itineraryServices = itineraryServices,
            selectedItineraryServiceList = selectedItineraryServiceList,
            isConcierge = isConcierge,
        )

    if (isClientInformationDialogExpanded)
        ItineraryServicesClientsDialog(
            clients = clients,
            itinerary = itineraryModel,
            onEvent = onEvent,
            onNavigation = onNavigation,
            onDismissRequest = {
                isClientInformationDialogExpanded = false
            },
        )

    if (isDatesDialogExpanded)
        ItineraryDatesDialog(
            state = state,
            onEvent = onEvent,
            itinerary = itineraryModel,
            onDismissRequest = {
                isDatesDialogExpanded = false
            },
        )

    if (isAllTaskDialogExpanded)
        TaskColumnDialog(
            getAllTask = state.getAllItineraryTask,
            onEditTask = { t ->
                onNavigation(EditItineraryNavigation.EditTask(t.id))
            },
            onEditTaskStatus = { t, s ->
                onEvent(EditItineraryEvent.EditTaskStatus(t.id, s))
            },
            onDeleteTask = { t ->
                onEvent(EditItineraryEvent.DeleteTask(t))
            },
            onDismissRequest = { isAllTaskDialogExpanded = false },
        )

    InvoicesDialog(
        isOpen = isInvoicesDialogOpen,
        getQuickbooksInvoices = invoiceState.getAllQuickbooksInvoices,
        loadingDownloadQuickbookIds = invoiceState.loadingDownloadQuickbookIds,
        downloadQuickbooksInvoiceState = invoiceState.downloadQuickbooksInvoice,
        enabled = state.getProfile.data?.role == ProfileModel.Role.Admin || state.getProfile.data?.role == ProfileModel.Role.Owner,
        onClick = { qbId ->
            val invoiceId = invoiceState.getAllInvoices.data
                ?.find { it.qbId == qbId }
                ?.id
                ?: return@InvoicesDialog

            onNavigation(
                EditItineraryNavigation.EditInvoice(
                    invoiceId = invoiceId,
                    proposalId = proposal?.id ?: "",
                    itineraryId = itineraryModel.id,
                ),
            )
        },
        onDownloadInvoice = { qb ->
            onInvoiceEvent(InvoiceEvent.DownloadInvoice(qb))
        },
        onDismissRequest = {
            isInvoicesDialogOpen = false
        },
    )

    EsDateRangePickerDialog(
        isExpanded = isDateRangePickerVisible,
        onDismissRequest = { isDateRangePickerVisible = false },
        fromDate = state.selectedFromDate.orEmpty(),
        toDate = state.selectedToDate.orEmpty(),
        onDateRangeChange = { from, to ->
            onEvent(
                EditItineraryEvent.GetAllItineraryServiceByDateRange(
                    from,
                    to,
                ),
            )
        },
    )
}
